import InfiniteScroll from 'react-infinite-scroll-component';
import { Role } from 'auth';
import { useCallback, useContext, useEffect, useState } from 'react';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useGetCurrentBusinessId } from '@/modules/common/hooks/useGetCurrentBusinessId.ts';
import DepartmentItem from '@/modules/admin-dashboard/components/items/DepartmentItem.tsx';
import { CreateDepartmentModal } from '@/modules/admin-dashboard/components/modals/CreateDepartmentModal.tsx';
import { useCurrentUserDepartmentsQuery } from '@/modules/admin-dashboard/queries/department.ts';
import { Button, EmptyListState, ModalProviderContext, PageLayout, SearchField, Spinner } from 'ui';

const Department = () => {
  const businessId = useGetCurrentBusinessId();
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue('');
  }, [businessId]);
  const { openModal } = useContext(ModalProviderContext);
  const {
    hasNextPage,
    fetchNextPage,
    data: departmentsData,
    isLoading,
  } = useCurrentUserDepartmentsQuery({
    page: 1,
    page_size: 18,
    filter_by_name: searchValue,
  });

  const departments = (departmentsData?.pages || []).flatMap(({ data }) => data);

  const handleOpenCreateDepartmentModal = useCallback(() => {
    openModal(CreateDepartmentModal);
  }, [openModal]);

  const headerAction = (
    <div className="flex flex-1 max-w-[450px] flex-wrap-reverse w-full justify-end items-center gap-3">
      <SearchField
        className="flex-1 !w-[240px]"
        placeholder="Search"
        value={searchValue}
        onChange={setSearchValue}
      />
      <Button
        onClick={handleOpenCreateDepartmentModal}
        variant="primary"
        className="flex-1 min-w-fit"
      >
        Add new department
      </Button>
    </div>
  );

  return (
    <PageLayout title="Departments" headerAction={headerAction}>
      {isLoading && (
        <div className="flex h-full w-full items-center justify-center">
          <Spinner size="lg" variant="primary" />
        </div>
      )}
      <EmptyListState
        title="No departments created yet"
        description="You can group users into departments and assign tasks into entire departments. You can create department from here"
        isLoading={isLoading}
        isSearchUsed={!!searchValue}
        itemsCount={departments.length}
      />
      {!!departments.length && (
        <InfiniteScroll
          next={fetchNextPage}
          dataLength={departments.length}
          hasMore={!!hasNextPage}
          className="w-full flex flex-col space-y-2"
          style={{ overflow: 'unset' }}
          loader={
            <div className="flex justify-center items-center h-16 w-full">
              <Spinner size="md" variant="primary" />
            </div>
          }
          scrollableTarget="scrollable"
        >
          {departments.map(department => (
            <DepartmentItem department={department} key={department.id} />
          ))}
        </InfiniteScroll>
      )}
    </PageLayout>
  );
};

export default withPrivateAccess(Department, Role.COMPLIANCE_ADMIN);
